import * as React from 'react';
import Div from "@jumbo/shared/Div";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { COMMON, LEADS } from 'app/utils/constants/endPoint';
import DataTable from 'app/components/DataTable/DataTable';
import DetailData from './DetailData';
import { requestApi } from 'app/utils/RestApi';
import { GENDER } from 'app/utils/constants/master';
import { isMobile } from 'react-device-detect';

const MicrositeListLeads = () => {
	const navigate = useNavigate();
	const [open, setOpen] = useState(false)
	const [selectedRow, setSelectedRow] = useState(null)
	const [canAddLeads, setCanAddLeads] = React.useState(true);

	const [userData, setUserData] = React.useState({});

	const filterData = [{
		id: "name",
		name: "Nama"
	}, {
		id: "phone",
		name: "Telepon Seluler"
	}, {
		id: "email",
		name: "Email"
	}, {
		id: "city",
		name: "Nama Kota"
	}]

	React.useEffect(() => {
		if (localStorage.getItem('userdata')) {
			const ls = localStorage.getItem('userdata')
			if (ls) {
				setUserData(JSON.parse(ls))
			}
		}
	}, []);
	React.useEffect(() => {
		document.querySelector("html").classList.add('overflow-hidden');
	}, [document]);

	React.useEffect(() => {
		if (userData != null) {
			initData();
		}
	}, [userData]);

	async function initData() {
		const { userLoggedin } = userData;
		
		if(userLoggedin?.referrerCode) {
			const res = await requestApi(COMMON.TNC_REFERRER, {
				subfolder: "/" + userLoggedin?.referrerCode
			})
	
	
			if (res?.data?.data) {
				setCanAddLeads(res.data.data.hasAgreeTnc && userLoggedin.referralStatus === 'REGISTERED')
			}
		}
	}


	const navigateAdd = () => {
		navigate('/micrositeAddLeads');
	}

	const openDetail = (params) => {
		setSelectedRow(params.row)
		setOpen(true)
	}

	const columns = [
		{ field: 'id', headerName: 'No.', width: isMobile ? 90 : 40 },
		{
			field: 'agentName', headerName: 'Nama Agen Penerima', width: isMobile ? 210 : 150,
			renderCell: (param) => (
				<span>{userData?.userLoggedin?.agent?.name}</span>
			),
		},
		{
			field: 'leadName', headerName: 'Nama Lead', width: 150,
			renderCell: (params) => (
				<div onClick={() => openDetail(params)}>
					{params.value}
				</div>
			),
		},
		{
			field: 'gender', headerName: 'Jenis Kelamin',
			renderCell: (params) => (
				<span>{GENDER[params.value]}</span>
			),
			width: 150
		},
		{ field: 'phone', headerName: 'Telepon Seluler', width: 200 },
		{ field: 'email', headerName: 'Email', width: 200 },
		{ field: 'city', headerName: 'Kota', width: 100 },
		{
			field: 'policyCount', headerName: 'Jml. Polis', width: isMobile ? 140 : 100,
			renderCell: (params) => (
				<span>{params.value ?? 0}</span>
			)
		},
		{
			field: 'referralFee', headerName: 'Jml. Referral Fee', width: isMobile ? 190 : 150,
			renderCell: (params) => (
				<span>{params.value ?? 0}</span>
			)
		}
	]

	return (
		<Div className='content-padding'>
			{/* <Div className='back-icon'>
				<KeyboardBackspaceIcon />
			</Div> */}
			<Row>
				<Col lg={12}>
					<Div sx={{ display: 'flex', justifyContent: 'flex-end', paddingLeft: '140px' }}>
						<Div sx={{ width: '16px' }} />
						<Div sx={{ paddingLeft: '10px' }}>
							<ButtonStyled
								onClick={navigateAdd}
								btnText={"Tambah Baru"}
								disabled={!canAddLeads}
								sx={{ minWidth: '164px' }}
							/>
						</Div>
					</Div>
				</Col>
			</Row>
			<Div className='white-container mt-4'>
				<Div className='section-header'>Lead Listing</Div>
				<Div sx={{ overflowX: 'auto' }}>
					<DataTable columns={columns} filterData={filterData} endPoint={LEADS.INDEX} downloadUrl={LEADS.LEADS_DOWNLOAD} />
				</Div>
			</Div>
			<DetailData open={open} handleClose={() => setOpen(false)} selectedRow={selectedRow} />
			{/* {countData > 0 &&
				<Div className='flex-justify-center' sx={{ marginTop: '35px' }}>
					<Pagination
						page={(params.pageIndex + 1)}
						onChange={handleChange}
						count={countData} className='pagination-wrapper' />
				</Div>
			} */}
		</Div>
	);
};

export default MicrositeListLeads;